import React from "react";
import T from "i18n-react";

interface IVenueShareProps {
  openShareDrawer: () => void;
  className: string;
  childClassName?: string;
}

export function VenueShare({
  openShareDrawer,
  className,
  childClassName,
}: IVenueShareProps) {
  return (
    <div className={className} onClick={openShareDrawer}>
      <span className="consumer-share"></span>
      <p className={childClassName}>{T.translate("Misc.share")}</p>
    </div>
  );
}
